import React from 'react';
import { FairAssessmentTab } from '../FairAssessmentTab';
import type { BASICScore } from '../CarrierTabs.types';

export interface FairAssessmentProps {
  dotNumber: number;
  basics: BASICScore[];
}

const FairAssessment: React.FC<FairAssessmentProps> = ({ dotNumber, basics }) => {
  return <FairAssessmentTab dotNumber={dotNumber} basics={basics} />;
};

export default FairAssessment;
